import '../grouped_elements/grouped_elements_filter_view.js.coffee'
Monitoring.Views.SocialContents.Filters ||= {}
Monitoring.Views.SocialContents.Filters.GroupedElements ||= {}

class Monitoring.Views.SocialContents.Filters.LabelsFilterView extends Monitoring.Views.SocialContents.Filters.GroupedElementsFilterView
  name: 'label'
  facetName: 'label'
  alias: 'Group'
  addMissing: true
  selectAll: true

  initialize: (@options = {}) ->
    super(@options)
    @facet_labels = @facet[@facetName]
    @terms = _.sortBy(_.clone(@facet_labels['terms']), (term) => @getDescription(term).toLowerCase())

  getGroupsLogic: () ->
    'first_group_elements':    @searchQuery.get(@withPrefix('primary_labels_logic')),
    'second_group_elements':   @searchQuery.get(@withPrefix('secondary_labels_logic')),
    'excluded_group_elements': @searchQuery.get(@withPrefix('excluded_labels_logic'))

  getGroupsElements: () ->
    first_group_elements: @withPrefix('primary_labels')
    second_group_elements: @withPrefix('secondary_labels')
    excluded_group_elements: @withPrefix('excluded_labels')

  viewFor: (viewId) =>
    new Monitoring.Views.SocialContents.Filters.LabelsFilterGroupView(@optionsFor(viewId))

  titles: ->
    first_group_elements: I18n.t('monitoring.taxonomy.first_group')
    second_group_elements: I18n.t('monitoring.taxonomy.second_group')
    excluded_group_elements: I18n.t('monitoring.taxonomy.excluded_group')

  onApply: =>
    @searchQuery.set(@withPrefix('primary_labels'), _.pluck(@firstGroupView.appliedElements, 'term'))
    @searchQuery.set(@withPrefix('primary_labels_logic'), @firstGroupView.logic)
    @searchQuery.set(@withPrefix('secondary_labels'), _.pluck(@secondGroupView.appliedElements, 'term'))
    @searchQuery.set(@withPrefix('secondary_labels_logic'), @secondGroupView.logic)
    @searchQuery.set(@withPrefix('excluded_labels'), _.pluck(@excludedGroupView.appliedElements, 'term'))
    @searchQuery.set(@withPrefix('excluded_labels_logic'), @excludedGroupView.logic)
    super

  _generateAllElements: (terms) ->
    labelsInContents = @facet_labels['terms']
    _.map(Keepcon.groups, (labelName) ->
      label = _.find(labelsInContents, (label) -> label['term'] == labelName) || {count: 0}
      return {term: labelName, count: label['count']}
    )

  getName: () ->
    'labels'

  _noValuesDescription: ->
    I18n.t('customer.dashboard.filters.creation.groups.no_groups')

  _allValuesDescription: ->
    I18n.t('customer.dashboard.filters.creation.groups.all_groups')
